import { useTranslation } from "react-i18next";
import styles from "./PricingCards.module.scss";

const plans = [
  { name: "LIGHT START", price: 100, messages: 12, color: styles.light },
  { name: "START", price: 200, messages: 15, color: styles.start },
  { name: "BUSINESS", price: 500, messages: 24, color: styles.business },
  { name: "ADVANCED", price: 750, messages: 56, color: styles.advanced },
  { name: "SILVER", price: 1000000, messages: 155, color: styles.silver },
  { name: "GOLD", price: 2000000, messages: 455, color: styles.gold },
  { name: "EMPIRE", price: 5000000, messages: 788, color: styles.empire },
];

export default function PricingCards() {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        {plans.slice(0, 4).map((plan) => (
          <div key={plan.name} className={`${styles.card} ${plan.color}`}>
            <h2>{plan.name}</h2>
            <div className={styles.cardContent}>
              <div className={styles.cardContentSection}>
                <p>{t("price")}</p>
                <h4 className={styles.count}>${plan.price.toLocaleString()}</h4>
              </div>
              <div className={styles.cardContentSection}>
                <p>{t("freeMessages")}</p>
                <h4 className={styles.count}>{plan.messages}</h4>
              </div>
            </div>
            <button className={styles.button}>{t("moreInfo")}</button>
          </div>
        ))}
      </div>
      <div className={styles.rowBottom}>
        {plans.slice(4).map((plan) => (
          <div key={plan.name} className={`${styles.card} ${plan.color}`}>
            <h2>{plan.name}</h2>
            <div className={styles.cardContent}>
              <div className={styles.cardContentSection}>
                <p>{t("price")}</p>
                <h4 className={styles.count}>${plan.price.toLocaleString()}</h4>
              </div>
              <div className={styles.cardContentSection}>
                <p>{t("freeMessages")}</p>
                <h4 className={styles.count}>{plan.messages}</h4>
              </div>
            </div>
            <button className={styles.button}>{t("moreInfo")}</button>
          </div>
        ))}
      </div>
    </div>
  );
}
